import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';
import api from '../lib/api';

const STORAGE_KEY = 'retreat-home-banner-dismissed-v1';

// Dorada announcement strip displayed at the top of public pages (after Navbar)
// announcing the next active retreat. Dismissible per browser.
const RetreatHomeBanner = () => {
  const [retreat, setRetreat] = useState(null);
  const [dismissed, setDismissed] = useState(true);
  const location = useLocation();

  // Hide on the retreat landing itself, private panel, admin areas
  const hiddenPrefixes = ['/retiros/', '/mi-retiro/', '/admin', '/login', '/register'];

  useEffect(() => {
    // Check dismissal flag synchronously
    setDismissed(Boolean(localStorage.getItem(STORAGE_KEY)));
    let cancelled = false;
    api.get('/retreats')
      .then(r => {
        const list = Array.isArray(r.data) ? r.data : [];
        const now = Date.now();
        const chosen = list.find(x => x.show_homepage_banner && x.date_start &&
          new Date(x.date_start).getTime() > now);
        if (!cancelled) setRetreat(chosen || null);
      })
      .catch(() => { if (!cancelled) setRetreat(null); });
    return () => { cancelled = true; };
  }, []);

  const dismiss = (e) => {
    e.preventDefault();
    e.stopPropagation();
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setDismissed(true);
  };

  if (!retreat || dismissed) return null;
  if (hiddenPrefixes.some(p => location.pathname.startsWith(p))) return null;

  const dateLabel = new Date(retreat.date_start).toLocaleDateString('es-ES', { day: 'numeric', month: 'long' });
  const dateEndLabel = new Date(retreat.date_end).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div
      className="relative w-full text-[#3a2e10]"
      style={{ background: 'linear-gradient(90deg, #E8C56B 0%, #D4A84B 50%, #E8C56B 100%)' }}
      data-testid="retreat-home-banner"
    >
      <Link
        to={`/retiros/${retreat.slug}`}
        className="block max-w-6xl mx-auto px-4 py-2 flex items-center justify-center gap-3 text-xs sm:text-sm hover:opacity-95 transition-opacity"
      >
        <Sparkles className="w-3.5 h-3.5 flex-shrink-0" />
        <span className="font-medium truncate">
          <strong>{retreat.title}</strong> · Retiro presencial del {dateLabel}–{dateEndLabel}
          <span className="hidden sm:inline"> · {retreat.location_city}</span>
        </span>
        <span className="hidden md:inline font-medium underline underline-offset-2 flex-shrink-0">
          Descubre el retiro →
        </span>
      </Link>
      <button
        onClick={dismiss}
        aria-label="Cerrar"
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-[#3a2e10]/10 rounded-full transition-colors"
        data-testid="retreat-banner-close"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default RetreatHomeBanner;
